var _path, _path2, _path3, _mask, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQcategory = function SvgQcategory(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10V2C3 1.46957 3.19156 0.96086 3.53253 0.585787C3.87351 0.210714 4.33597 0 4.81818 0H21.1818C21.664 0 22.1265 0.210714 22.4675 0.585787C22.8084 0.96086 23 1.46957 23 2V10H3Z",
    fill: "#F9A600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10V2C13 1.46957 13.0958 0.96086 13.2663 0.585787C13.4368 0.210714 13.668 0 13.9091 0H22.0909C22.332 0 22.5632 0.210714 22.7337 0.585787C22.9042 0.96086 23 1.46957 23 2V10H13Z",
    fill: "#DD9300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4403 13C22.8225 13 23.1946 12.8638 23.5025 12.6114C23.8103 12.3589 24.0379 12.0034 24.1518 11.5965L25.9296 5.25135C25.9763 5.08475 26 4.91121 26 4.73666V4.72555C26 4.26791 25.837 3.82901 25.5469 3.5054C25.2568 3.1818 24.8633 3 24.453 3C24.1221 3 23.8 3.1183 23.5339 3.33753C23.2677 3.55677 23.0716 3.86539 22.9743 4.21809L21.5172 9.5H4.48276L3.02568 4.21809C2.92838 3.86539 2.73228 3.55677 2.46615 3.33753C2.20002 3.1183 1.87789 3 1.54705 3C1.34389 3 1.14271 3.04463 0.955018 3.13135C0.767322 3.21807 0.596776 3.34517 0.45312 3.5054C0.309463 3.66563 0.195508 3.85586 0.117762 4.06521C0.0400156 4.27456 0 4.49895 0 4.72555V4.73666C1.11707e-07 4.91121 0.0237441 5.08475 0.0704213 5.25135L1.84817 11.5965C1.96215 12.0034 2.18966 12.3589 2.49753 12.6114C2.8054 12.8638 3.17753 13 3.55965 13H22.4403Z",
    fill: "#FFD245"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 26,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4403 13C22.8225 13 23.1946 12.8638 23.5025 12.6114C23.8103 12.3589 24.0379 12.0034 24.1518 11.5965L25.9296 5.25135C25.9763 5.08475 26 4.91121 26 4.73666V4.72555C26 4.26791 25.837 3.82901 25.5469 3.5054C25.2568 3.1818 24.8633 3 24.453 3C24.1221 3 23.8 3.1183 23.5339 3.33753C23.2677 3.55677 23.0716 3.86539 22.9743 4.21809L21.5172 9.5H4.48276L3.02568 4.21809C2.92838 3.86539 2.73228 3.55677 2.46615 3.33753C2.20002 3.1183 1.87789 3 1.54705 3C1.34389 3 1.14271 3.04463 0.955018 3.13135C0.767321 3.21807 0.596776 3.34517 0.45312 3.5054C0.309463 3.66563 0.195508 3.85586 0.117762 4.06521C0.0400156 4.27456 0 4.49895 0 4.72555V4.73666C1.11707e-07 4.91121 0.0237441 5.08475 0.0704213 5.25135L1.84817 11.5965C1.96215 12.0034 2.18966 12.3589 2.49753 12.6114C2.8054 12.8638 3.17753 13 3.55965 13H22.4403Z",
    fill: "#FFDD7B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 3H26V13H13V3Z",
    fill: "#FAC623"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42105 7H11.5789C11.9558 7 12.3173 7.18964 12.5838 7.52721C12.8503 7.86477 13 8.32261 13 8.8V10H4V8.8C4 8.32261 4.14972 7.86477 4.41622 7.52721C4.68272 7.18964 5.04417 7 5.42105 7V7Z",
    fill: "#F6BB00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4211 7H20.5789C20.9558 7 21.3173 7.18964 21.5838 7.52721C21.8503 7.86477 22 8.32261 22 8.8V10H13V8.8C13 8.32261 13.1497 7.86477 13.4162 7.52721C13.6827 7.18964 14.0442 7 14.4211 7Z",
    fill: "#EDA600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96875 3.3125H6.90625V4.25H5.96875V3.3125Z",
    fill: "#CF8300"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 3.3125H10.1875V4.25H9.25V3.3125Z",
    fill: "#CF8300"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5312 3.3125H13.4688V4.25H12.5312V3.3125Z",
    fill: "#CF8300"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 3.3125H16.75V4.25H15.8125V3.3125Z",
    fill: "#CF8300"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0938 3.3125H20.0312V4.25H19.0938V3.3125Z",
    fill: "#CF8300"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13L3 16H4L6 13H3.5Z",
    fill: "#B1712C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13L23 16H22L20 13H22.5Z",
    fill: "#B1712C"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQcategory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/qcategory.05f1960e3cacb327d0780c45b52490b6.svg";